import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, Pane } from 'evergreen-ui';

import { getShops } from '../actions/ShopActions';
import DataTable from '../../common/DataTable/DataTable';

class ListShops extends Component {
    handleTableChange = (opts) => {
        this.props.dispatch(getShops(opts));
    }

    render() {
        return (
            <>
                <Pane display="flex" marginBottom={16}>
                    <Pane>
                        <Link to="/shops/create">
                            <Button iconBefore="add" intent="none" appearance="primary">
                                Magazin nou
                            </Button>
                        </Link>
                    </Pane>
                </Pane>
                <DataTable
                    defaultFilter="id"
                    defaultDirection="desc"
                    columns={[
                        { id: 'id', label: 'Id' },
                        { id: 'name', label: 'Nume' },
                        { id: 'address', label: 'Adresă' },
                        { id: 'phone', label: 'Telefon' },
                        { id: 'minStaffPerShift', label: 'Personal Minim' },
                        { 
                            id: 'active', 
                            label: 'Status',
                            decorator: (value) => value ? '✓ Activ' : '✗ Inactiv'
                        },
                        { id: 'createdAt', label: 'Creat', decorator: 'date' }
                    ]}
                    data={this.props.data}
                    onTableChange={this.handleTableChange}
                    updateKey={this.props.data}
                    page={this.props.page}
                    pageSize={this.props.pageSize}
                    pageCount={this.props.pageCount}
                    itemMenu={[
                        { getLink: (item) => `/shops/${item[0]}`, label: 'Detalii', icon: 'eye-open' },
                        { getLink: (item) => `/shops/${item[0]}/edit`, label: 'Editează', icon: 'edit' }
                    ]}
                />
            </>
        );
    }
}

function mapStateToProps(state) {
    return state.shops;
}

export default connect(mapStateToProps)(ListShops);
